import { createFileRoute } from "@tanstack/react-router";
import { MagicLinkPage } from "../features/auth/MagicLinkPage";

/**
 * `/signin?token=` — the sign-in link that is always the web app.
 *
 * Deliberately not under `/auth/magic`, which the iOS app claims as a universal
 * link. iOS decides whether to open the app from a file Apple serves through their
 * own CDN and caches, so excluding a path there does not take effect for a device
 * that already holds the old copy. A path the app has never claimed is never taken,
 * cache or no cache — which is the only way to be sure somebody asking for the web
 * app on their phone actually gets it.
 */
export const Route = createFileRoute("/signin")({
  validateSearch: (s: Record<string, unknown>): { token: string; next?: string } => ({
    token: typeof s.token === "string" ? s.token : "",
    ...(typeof s.next === "string" && s.next.startsWith("/") && !s.next.startsWith("//")
      ? { next: s.next }
      : {}),
  }),
  component: () => {
    const { token, next } = Route.useSearch();
    // browser: this link exists to finish here. No handoff, no question.
    return <MagicLinkPage token={token} next={next} browser />;
  },
});
